export const shouldDisableProcedureProduct = ({ superbill = null, procedure = null }) => {
  if (!superbill) return;

  const isClinicalNoteLocked =
    superbill?.encounter?.appointment?.medicalHistory?.state === 'finalized' &&
    superbill?.encounter?.appointment?.medicalHistory?.locked;

  return isClinicalNoteLocked && procedure?.uuid;
};
